import {IS_LOGGED_IN, IS_STAGING, PLAYER_ID, USE_NEW_BANKING_EVENT_LISTENER} from "Setup/config";
import {sendGA4Event} from "Helpers/gaEvents";
import {sendLogglyEvent} from "Helpers/loggly";
import ErrorBoundary from "Components/ErrorBoundary";
import {useEffect, useRef} from "react";
import useBanking from "Hooks/api/useBanking";
import {setHasDeposited} from "Redux/actions/morpheus";
import {useDispatch} from "react-redux";
import useBankingTracking from "Hooks/api/useBankingTracking";

const sendMessagesFromSafechargeToLoggly = true;
const sendLogglyEventBankingEventListener = (message, json) => sendMessagesFromSafechargeToLoggly ? sendLogglyEvent('Safecharge', message, json) : null;

const _BankingEventListener = ({hasError}) => {
    const dispatch = useDispatch();
    const {hasDeposited} = useBanking({});
    const {sendDepositTrackingEvent, sendWithdrawalTrackingEvent} = useBankingTracking();
    const isFTDRef = useRef(!hasDeposited);

    if (hasError) return null;
    if (!IS_LOGGED_IN || !USE_NEW_BANKING_EVENT_LISTENER) return null;

    const _setHasDeposited = () => {
        if (isFTDRef.current) {
            dispatch(setHasDeposited());
            isFTDRef.current = false;
        }
    };

    const listenForBankingWindowEvents = (evt) => {
        if (evt.origin.includes("safecharge") && evt?.data) {
            try {
                const parsedMessage = JSON.parse(evt.data);

                if (parsedMessage) {
                    // Catch successful withdrawal requests
                    if(parsedMessage?.payload === "successfulWithdrawalRequest" && parsedMessage?.amount){
                        sendWithdrawalTrackingEvent(true, parsedMessage?.amount);
                    }

                    // if(parsedMessage?.payload?.action === "withdrawal_request_created" && parsedMessage?.payload?.amount){
                    //     sendWithdrawalTrackingEvent(true, parsedMessage?.payload?.amount);
                    // }

                    // Catch successful and failed deposit events
                    if (parsedMessage?.payload?.action) {
                        const newAction = parsedMessage.payload.action;
                        const successfulActionsToWatch = ["made deposit", "made first deposit"];
                        const failActionsToWatch = ["failed  deposit", "failed  first deposit"];

                        let depositValue = 0;
                        if (parsedMessage?.payload?.deposit_amount) {
                            depositValue = Number(parsedMessage.payload.deposit_amount).toFixed(2);

                            console.log(`%cSuccessful Deposit : £${depositValue}`, 'color: green;');
                            console.log(parsedMessage);
                        }

                        if (successfulActionsToWatch.includes(newAction)) {
                            if (isFTDRef.current) {
                                if (!IS_STAGING) {
                                    window.dataLayer.push({event: 'firstDeposit_v2'});

                                    sendGA4Event('purchase_FTD', {
                                        currency: 'GBP',
                                        player_id: PLAYER_ID,
                                        value: depositValue
                                    });
                                }
                            }

                            sendGA4Event('purchase', {
                                currency: 'GBP',
                                player_id: PLAYER_ID,
                                value: depositValue
                            });

                            sendDepositTrackingEvent(true, depositValue);
                            sendLogglyEventBankingEventListener(`${isFTDRef.current ? 'First ' : ''}Deposit from the banking client`, parsedMessage);
                            _setHasDeposited();
                        }

                        if (failActionsToWatch.includes(newAction)) {
                            sendDepositTrackingEvent(false, depositValue);
                        }
                    }

                    sendLogglyEventBankingEventListener('Message from the banking client', parsedMessage);
                }
            } catch (error) {
                sendLogglyEventBankingEventListener('Error in bankingModalListener', error);
            }
        }
    };

    useEffect(() => {
        window.addEventListener('message', listenForBankingWindowEvents, false);

        return () => {
            window.removeEventListener('message', listenForBankingWindowEvents, false);
        }
    }, []);

    return null;
};

const BankingEventListener = () => (
    <ErrorBoundary>
        <_BankingEventListener/>
    </ErrorBoundary>
);

export default BankingEventListener;
